import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { FileLabel, FileLogStatus } from "shared/types/file";
import { UnitConformityInfo, UnitConformityStatus } from "shared/types/unit-conformity-info.dto";

// Calculate the date for 3 months from now
const threeMonthsFromNow = new Date();
threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

export const calculateConformityStatusDotValues = async (conformityInfo: UnitConformityInfo, unit: any, session: any) => {
    let dotValues = {
        red: { count: 0, labels: [] as string[] },
        orange: { count: 0, labels: [] as string[] },
        green: { count: 0, labels: [] as string[] },
        transparent: { count: 0, labels: [] as string[] },
    };

    try {
        // Fetch conformity certificate file logs
        const queryParams = new URLSearchParams();
        if (unit?.id) {
            queryParams.append('unitId', unit.id);
        }

        const labels = [
            FileLabel.ConformiteitsattestUnit,
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        const currentDate = new Date();

        // Check for conformity certificate
        const certificateLogs = fileLogs.filter((log: any) =>
            log.label.includes(FileLabel.ConformiteitsattestUnit)
        ).sort((a: any, b: any) => new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime());

        // Find the most recent valid certificate
        const validCertificate = certificateLogs.find((cert: any) => {
            const expirationDate = cert.expirationDate ? new Date(cert.expirationDate) : null;
            return (cert.status === FileLogStatus.OK || cert.status === FileLogStatus.OK_WITH_REMARKS) 
                && (!expirationDate || expirationDate > currentDate);
        });

        if (certificateLogs.length && validCertificate) {
            dotValues.green.count++;
            dotValues.green.labels.push("Conformiteitsattest aanwezig");
            
            // Check if it's about to expire
            const expirationDate = validCertificate.expirationDate ? new Date(validCertificate.expirationDate) : null;
            if (expirationDate && expirationDate <= threeMonthsFromNow) {
                dotValues.orange.count++;
                dotValues.orange.labels.push("Conformiteitsattest verloopt binnen drie maanden");
            }
            
            // Check if it has remarks
            if (validCertificate.status === FileLogStatus.OK_WITH_REMARKS) {
                dotValues.orange.count++;
                dotValues.orange.labels.push("Conformiteitsattest met opmerkingen");
            }
        } else if (conformityInfo.unitConformity != UnitConformityStatus.NOT_REQUIRED) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen conformiteitsattest aanwezig");
        }

        // Unit conformiteitsstatus
        if (conformityInfo.unitConformity == UnitConformityStatus.NOT_REQUIRED) {
            dotValues.green.count++;
            dotValues.green.labels.push("Conformiteitsattest niet vereist");
        } else if (conformityInfo.unitConformity == UnitConformityStatus.OK) {
            dotValues.green.count++;
            dotValues.green.labels.push("Woonconformiteit OK");
        } else if (conformityInfo.unitConformity == UnitConformityStatus.NOT_OK) {
            dotValues.red.count++;
            dotValues.red.labels.push("Woonconformiteit NIET OK");
        } else if (conformityInfo.unitConformity == UnitConformityStatus.PARTIAL_OK) {
            dotValues.orange.count++;
            dotValues.orange.labels.push("Woonconformiteit OK, met opmerkingen");
        } else {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Woonconformiteitsstatus onbekend");
        }

        if (conformityInfo.unitMaxCapacityPersons) {
            dotValues.green.count++;
            dotValues.green.labels.push("Maximale capaciteit woning gekend");
        } else {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Maximale capaciteit woning niet ingevuld");
        }
    } catch (error) {
        console.error('Error fetching conformity file logs:', error);
    }

    return dotValues;
};
